import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getDeals } from '@services/deal.service';
import { IDeal } from '@interfaces/deal';

export const fetchListDeals = createAsyncThunk('voucher/fetchDealByMerchantId', async (merchantId: string) => {
	return await getDeals(merchantId);
});

export interface DealState {
	deals: IDeal[];
	isLoading: boolean;
	isRefreshing: boolean;
}

const initialState = {
	deals: [],
	isLoading: true,
	isRefreshing: false,
} satisfies DealState as DealState;

const dealSlice = createSlice({
	name: 'deals',
	initialState: initialState,
	reducers: {
		fetchDeals: (state, action: PayloadAction<DealState>) => {
			return {
				...state.deals,
				...action.payload,
			};
		},
		setRefreshing: (state, action: PayloadAction<boolean>) => {
			state.isRefreshing = action.payload;
		},
	},
	extraReducers(builder) {
		builder.addCase(fetchListDeals.pending, (state: DealState) => {
			if (state.deals.length === 0) {
				state.isLoading = true;
			}
		});
		builder.addCase(fetchListDeals.fulfilled, (state: DealState, action) => {
			state.isLoading = false;
			state.isRefreshing = false;
			state.deals = (action.payload as any)['data'] ?? [];
		});
		builder.addCase(fetchListDeals.rejected, (state: DealState) => {
			state.isLoading = false;
			state.isRefreshing = false;
		});
	},
});

export const dealReducer = dealSlice.reducer;
export const { setRefreshing } = dealSlice.actions;
export default dealSlice;
